module Meevo.Plugins.MerchantAccountsOnboardingTesting {
    angular.module("meevo.plugins.merchantAccountsOnboardingTesting", []);
}